import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import DadosParametrizados from '../../alertas/cadastroDadosParametrizados/cadastroDadosParametrizados.page';
import Geo from '../../alertas/CadastroGeo/cadastroGeo.page';
import Analise from '../../alertas/cadastroAnalise/cadastroAnalise.page';
import Audiencia from '../../alertas/CadastroAudiencia/cadastroaudiencia.page';
import Tab from '../../../components/Tabs/tabs.component';

class TabNavigation extends Component {
	state = {
		activeTab: '',
	};

	componentDidMount() {
		const { match: { params } } = this.props;
		const tab = params.page;
		this.setState({
			activeTab: tab,
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.page !== this.props.match.params.page) {
			this.setState({
				activeTab: this.props.match.params.page,
			});
		}
	}

	getParams() {
		const { match: { params } } = this.props;
		return params.id;
	}

	handleClick = (valor) => {
		const { history } = this.props;

		this.setState({
			activeTab: valor,
		});

		history.push(`/alerta/${valor}/${this.getParams()}`);
	};

	render() {
		const { match } = this.props;
		const { activeTab } = this.state;

		return (
			<div className='card container mt-5'>
				<div className='card-body'>
					<div className='tabs custom-tab'>
						<nav>
							<ul>
								<Tab
									label='Dados parametrizados'
									valor='dados'
									activeTab={activeTab}
									onClick={() => this.handleClick('dados')}
									icon='dados'
								/>
								<Tab
									label='Geo'
									valor='geo'
									activeTab={activeTab}
									onClick={() => this.handleClick('geo')}
									icon='globe'
								/>
								<Tab
									label='Análise'
									valor='analise'
									activeTab={activeTab}
									onClick={() => this.handleClick('analise')}
									icon='analytics'
								/>
								<Tab
									label='Audiência'
									valor='audiencia'
									activeTab={activeTab}
									onClick={() => this.handleClick('audiencia')}
									icon='audiencia'
								/>
							</ul>
						</nav>
						<div>
							{match.params.page === 'dados'
								&& (
									<DadosParametrizados
										onClick={this.handleClick}
										alertaId={this.getParams()}
										className='section-dados'
									/>
								)
							}
							{match.params.page === 'geo'
										&& (
											<Geo
												onClick={this.handleClick}
												alertaId={this.getParams()}
												className='section-geo'
											/>
										)
							}
							{match.params.page === 'analise'
										&& (
											<Analise
												onClick={this.handleClick}
												alertaId={this.getParams()}
												className='section-analise'
											/>
										)
							}
							{match.params.page === 'audiencia'
										&& (
											<Audiencia
												history={this.props.history}
												onClick={this.handleClick}
												alertaId={this.getParams()}
												className='section-audiencia'
											/>
										)
							}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default withRouter(TabNavigation);
